import React from 'react';

const AIInsightsIconNew = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      height="18"
      width="18"
      fill="none"
      stroke="none"
      viewBox="0 0 18 18"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.25863 0.403321C8.45761 -0.134414 9.21817 -0.134414 9.41715 0.403321L11.4402 5.87063C11.5028 6.03969 11.6361 6.17298 11.8052 6.23554L17.2725 8.25863C17.8102 8.45761 17.8102 9.21817 17.2725 9.41715L11.8052 11.4402C11.6361 11.5028 11.5028 11.6361 11.4402 11.8052L9.41715 17.2725C9.21817 17.8102 8.45761 17.8102 8.25863 17.2725L6.23554 11.8052C6.17298 11.6361 6.03969 11.5028 5.87063 11.4402L0.403321 9.41715C-0.134414 9.21817 -0.134414 8.45761 0.403321 8.25863L5.87063 6.23554C6.03969 6.17298 6.17298 6.03969 6.23554 5.87063L8.25863 0.403321Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default AIInsightsIconNew;
